module.exports = __webpack_public_path__ + "img/d3.b544613e.png";